/** Batch job / flow step progress indicator. */

import { Box, LinearProgress, Typography } from "@mui/material";

interface Props {
  completed: number;
  total: number;
  failed?: number;
  /** Label suffix — defaults to "completed". Use "steps" for flow progress. */
  label?: string;
}

export default function ProgressIndicator({ completed, total, failed = 0, label = "completed" }: Props) {
  const pct = total > 0 ? (completed / total) * 100 : 0;
  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
        <Typography variant="body2">{completed}/{total} {label}</Typography>
        {failed > 0 && <Typography variant="body2" color="error">{failed} failed</Typography>}
      </Box>
      <LinearProgress variant="determinate" value={pct} />
    </Box>
  );
}
